// ========================================
// 📄 src/hooks/useInteractions.js
// ========================================
import { useState, useEffect } from "react";
import { interactionService } from "../services/interactionService";

export const useInteractions = (leadId) => {
  const [interactions, setInteractions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadInteractions = async () => {
    if (!leadId) return;

    try {
      setLoading(true);
      const data = await interactionService.getInteractionsByLead(leadId);
      setInteractions(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInteractions();
  }, [leadId]);

  return { interactions, loading, error, refetch: loadInteractions };
};
